"use client";

import { createContext, useContext } from "react";
import type { NotificationListLayout } from "./notification-list";

export interface NotificationListContextValue {
  layout: NotificationListLayout;
}

export type NotificationPriority = "high" | "medium" | "low";

export const NotificationListContext = createContext<NotificationListContextValue | null>(null);

export const useNotificationList = (): NotificationListContextValue => {
  const ctx = useContext(NotificationListContext);
  if (!ctx) throw new Error("NotificationList parts must be used within <NotificationList>.");
  return ctx;
};
